export enum ActionType {
  REGISTER_REQUEST = 'register_request',
  REGISTER_SUCCESS = 'register_success',
  REGISTER_ERROR = 'register_error'
}
